// Single place where build-time configuration is read.
//
// Vite exposes VITE_* by default; vite.config.ts also allows REACT_APP_* so the
// ENV_PROD deploy secret keeps working while it still uses the old names. Once
// that secret is updated, drop the REACT_APP_ fallbacks here and the extra
// entry in envPrefix.
export const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  import.meta.env.REACT_APP_API_URL ||
  'https://api.eternal-health.com/api';

export const INVITE_BASE_URL =
  import.meta.env.VITE_INVITE_BASE_URL ||
  import.meta.env.REACT_APP_INVITE_BASE_URL ||
  'http://localhost:8001';
